import styles from 'styles/TwoColumns.module.css'

const TwoColumns = ({ children }) => (
    <div className={styles.grid}>
        { children }
    </div>
)

export default TwoColumns